import request from '@/request'
import { USER } from '@/data/api'
import { objQueryString } from '@/util'

export default {
  namespaced: true,
  state: {
    userList: [],
    limit: 3,
    pagination: {
      page: 1,
      lastPage: 0,
      total: 0
    },
    search: ''
  },
  getters: {
    userList: state => state.userList,
    lastPage: state => state.pagination.lastPage,
    total: state => state.pagination.total,
    currentPage: state => state.pagination.page,
    search: state => state.search,
    isFilterApplied: (state) => {
      return !!state.search
    }
  },
  mutations: {
    setUserList (state, items) {
      state.userList = items
    },
    setPage (state, page) {
      state.pagination.page = page
    },
    setLastPage (state, page) {
      state.pagination.lastPage = page
    },
    setSearch (state, search) {
      state.search = search
    },
    setTotal (state, count) {
      state.pagination.total = count
    }
  },
  actions: {
    async get ({ commit, getters }, params) {
      try {
        const queryParams = {
          page: getters.currentPage,
          keyword: getters.search
        }
        const { data } = await request.get(`${USER.RESOURCE}?${objQueryString(queryParams)}`)
        commit('setUserList', data.data)
        commit('setLastPage', data.meta.last_page)
        commit('setTotal', data.meta.total)
      } catch (e) {
        commit('setUserList', [])
        commit('setLastPage', 0)
        commit('setTotal', 0)
      }
    },
    async add ({ commit }, params) {
      try {
        await request.post(USER.CREATE, params)
      } catch (e) {
        throw e
      }
    },
    resetPage ({ commit }, payload) {
      if (payload.resetPage) {
        commit('setPage', 1)
      }
    },
    resetFilters ({ commit }) {
      commit('setSearch', '')
    },
    async update (context, params) {
      try {
        await request.put(`${USER.RESOURCE}/${params.uuid}`, params.form)
      } catch (e) {
        throw e
      }
    },
    async delete (context, id) {
      try {
        await request.delete(`${USER.RESOURCE}/${id}`)
        return
      } catch (e) {
        throw e
      }
    },
    async enable (context, id) {
      try {
        await request.post(`${USER.ENABLE}/${id}`)
        return
      } catch (e) {
        throw e
      }
    },
    async forceDelete (context, id) {
      try {
        await request.post(`${USER.FORCE_DELETE}/${id}`)
        return
      } catch (e) {
        throw e
      }
    }
  }
}
